import React from 'react';
import { ConnectedSwapButton } from './SwapButton';
import { SwapButtonMobileEl } from './SwapButtonMobile.style';
import { ABUtils } from '../../../../utils';

export const SwapButtonMobile = () => {
    const { isCssVariationMobile } = ABUtils.getABs();
    const getRotateStyle = (rotate) => rotate ? 'rotate(270deg)' : 'rotate(90deg)';

    return (
        <SwapButtonMobileEl
            className="odf-space-outer-right-xl odf-z-index-2 odf-position-absolute"
            isCssVariationMobile={isCssVariationMobile}
        >
            <ConnectedSwapButton
                buttonClass="odf-btn-circle-lg"
                getRotateStyle={getRotateStyle}
            />
        </SwapButtonMobileEl>
    );
};
